module.exports = "/_next/static/images/c3f866880acab607671f27f5a8ce7bd4-openBankingConfirmation.svg";